// extracted by mini-css-extract-plugin
export default {"CreateDevice":"ModalComponent_CreateDevice__VCct4"};